module.exports = __webpack_public_path__ + "web/img/level-3.a5e43a79.png";